import * as Yup from 'yup';

const RegisterOtpSchema = Yup.object().shape({
    otp: Yup.string()
        .required('One time password is required'),
});

export default RegisterOtpSchema;